// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Separator_wrapper__QB2_V","circle":"Separator_circle__w9IaG","line":"Separator_line__22rhF","body":"Separator_body__2Pv_Z"};